import BlogThirtyTwoContainer from "./container/BlogThirtyTwoContainer";
export default BlogThirtyTwoContainer;
